import type { Infer } from 'superstruct';
import { object, string } from 'superstruct';
import { notEmpty } from '../../../../form';

export const ForgotPasswordValidation = object({
  email: notEmpty(string()),
});

export type ForgotPasswordFields = Infer<typeof ForgotPasswordValidation>;
